import { AppError } from './app-error.model';
export class UnauthorizedError extends AppError {

}
